import { useEffect, useState } from "react";

export default function CrossfadeSlider({ images, alt, interval = 5000, testid = "crossfade-slider" }) {
  const [idx, setIdx] = useState(0);
  const [prev, setPrev] = useState(null);

  const go = (next) => {
    if (next === idx) return;
    setPrev(idx);
    setIdx(next);
  };

  useEffect(() => {
    images.forEach((src) => { const img = new Image(); img.src = src; });
  }, [images]);

  useEffect(() => {
    const id = setTimeout(() => go((idx + 1) % images.length), interval);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idx, images.length, interval]);

  return (
    <div className="relative w-full h-full bg-[#EDEBE6]" data-testid={testid}>
      {images.map((src, i) => {
        const active = i === idx;
        const under = i === prev;
        return (
          <img
            key={src}
            src={src}
            alt={`${alt} ${i + 1}`}
            aria-hidden={!active}
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03]"
            style={{
              opacity: active || under ? 1 : 0,
              zIndex: active ? 2 : under ? 1 : 0,
              transition: active
                ? "opacity 1800ms cubic-bezier(0.4, 0, 0.2, 1), transform 1500ms ease-out"
                : "transform 1500ms ease-out",
            }}
          />
        );
      })}
      <div className="absolute bottom-5 right-5 z-10 flex gap-2">
        {images.map((_, i) => (
          <button
            key={i}
            type="button"
            aria-label={`Show image ${i + 1}`}
            data-testid={`${testid}-dot-${i}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); go(i); }}
            className="py-2"
          >
            <span className={`block h-px transition-[width,background-color] duration-500 ${i === idx ? "w-10 bg-white" : "w-5 bg-white/50 hover:bg-white/80"}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
